import { render, staticRenderFns } from "./onlineSignature.vue?vue&type=template&id=4b386ed6&scoped=true"
import script from "./onlineSignature.vue?vue&type=script&lang=js"
export * from "./onlineSignature.vue?vue&type=script&lang=js"
import style0 from "./onlineSignature.vue?vue&type=style&index=0&id=4b386ed6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b386ed6",
  null
  
)

export default component.exports